import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ConfirmationModal, IconButton, useOverlayContext } from 'seagull';
import { Trash } from 'seagull/icons';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { ErrorResponse, ServerError } from '~/infra/ErrorResponse';
export function CreditDeleteButton(props) {
    const { chargeId, agreementId, disabled, tooltipTitle, testId, onRefresh } = props;
    const { t: texts } = useLocaleKeys('pages.agreementMinisite');
    const { t: commonTexts } = useLocaleKeys('common');
    const [loading, setLoading] = useState(false);
    const overlayContext = useOverlayContext();
    const { api, logBI } = useStoreActions();
    async function onDelete() {
        const confirmed = await overlayContext.showModal({
            biName: 'credit_delete_button_credit_delete_confirm',
            closeOnClickOutside: true,
            shouldBlurBackground: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'credit_delete_button_confirm'
                        },
                        secondaryButton: {
                            name: 'credit_delete_button_cancel'
                        }
                    },
                    skin: "danger",
                    title: texts.creditDeleteTitle(),
                    content: texts.creditDeleteContent(),
                    primaryButtonLabel: commonTexts.buttons.removeCredit(),
                    secondaryButtonLabel: commonTexts.buttons.cancel(),
                    onPrimaryButtonClick: ()=>dismissModal(true),
                    onSecondaryButtonClick: ()=>dismissModal(false)
                });
            }
        });
        if (!confirmed) return;
        setLoading(true);
        logBI(10567);
        try {
            await api.charge.deleteCredit(agreementId, chargeId);
            await onRefresh({
                silent: true
            });
            overlayContext.showSuccessToast(commonTexts.toasts.creditRemoved(), "".concat(testId, "-success"));
        } catch (err) {
            setLoading(false);
            const e = new ErrorResponse(err);
            const errorText = e.hasServerError(ServerError.AdHocChargeNotFound) ? 'Failed to remove credit. It was already removed' : 'Failed to remove credit, please try again or contact support@sayanchor.com for assistance';
            overlayContext.showErrorToast(errorText, "".concat(testId, "-failure"));
        }
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        bi: {
            name: 'remove_credit'
        },
        onClick: onDelete,
        disabled: disabled || loading,
        skin: "primary",
        testId: testId,
        intent: Intent.RemoveCredit,
        tooltip: {
            placement: 'top',
            title: /*#__PURE__*/ _jsx("div", {
                "data-testid": testId && "".concat(testId, "-tooltip"),
                children: tooltipTitle || 'Remove credit'
            })
        },
        children: /*#__PURE__*/ _jsx(Trash, {
            size: 20
        })
    });
}
